<div
  class="dialog--overlay"
  *ngIf="isOpen()"
  (click)="onOverlayClick($event)"
  [class.centered]="centered"
>
  <div class="dialog--base" [attr.data-test-id]="testId">
    <button class="dialog--close" (click)="onClose($event)">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.4141 12L18.9531 17.539C19.4466 18.1455 19.4858 18.6562 19.071 19.0711C18.6562 19.4859 18.1455 19.4466 17.5389 18.9532L11.9999 13.4142L6.46093 18.9532C5.85439 19.4466 5.34435 19.4866 4.93082 19.073C4.51729 18.6595 4.55592 18.1481 5.04671 17.539L10.5857 12L5.04671 6.46099C4.55381 5.85396 4.51452 5.34327 4.92886 4.92893C5.3432 4.51459 5.85389 4.55387 6.46093 5.04678L11.9999 10.5858L17.5389 5.04678C18.1455 4.55337 18.6562 4.51409 19.071 4.92893C19.4858 5.34376 19.4466 5.85445 18.9531 6.46099L13.4141 12Z"
          fill="#B3B6BA"
        />
      </svg>
    </button>
    <ng-content></ng-content>
  </div>
</div>
